var _defs, _path, _circle, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrizeWheel3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.55 32.85"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;stroke:#fff;stroke-width:.9px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.54 17.57A15.27 15.27 0 0017.36 2.44v1.41A13.88 13.88 0 111.39 17.57 13.9 13.9 0 0113.05 3.83V2.42a15.27 15.27 0 1017.49 15.15",
    fill: "#fff",
    fillRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 15.57,
    cy: 17.58,
    r: 3.63
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73 4.74l4.08 9.34m7-9.34l-3.54 9.34",
    strokeLinecap: "round",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.15.52l-2.48 6L12 1.18z"
  })));
}

SvgPrizeWheel3.displayName = 'PrizeWheel3';
export default SvgPrizeWheel3;